// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3rqDW","rightAdornment":"Header_rightAdornment__2o9qu"};